import useApiPrivateClient from "../../hooks/useApiPrivateClient";
import { CreateCityData, CreateCountryData } from "./location.requests";
import { City, Country } from "./location.responses";

const useLocationService = () => {
  const apiPrivateClient = useApiPrivateClient();

  const createCountry = (countryData: CreateCountryData) => {
    return apiPrivateClient.post<Country>("/countries", countryData);
  };

  const getCountries = () => {
    return apiPrivateClient.get<Country[]>("/countries");
  };

  const getCountry = (countryId: number) => {
    return apiPrivateClient.get<Country>(`/countries/${countryId}`);
  };

  const updateCountry = (countryId: number, updateData: CreateCountryData) => {
    return apiPrivateClient.patch<Country>(
      `/countries/${countryId}`,
      updateData
    );
  };

  const deleteCountry = (countryId: number) => {
    return apiPrivateClient.delete<Country>(`/countries/${countryId}`);
  };

  const getAllCities = () => {
    return apiPrivateClient.get<City[]>("/countries/cities");
  };

  const getAllCitiesInCountry = (countryId: number) => {
    return apiPrivateClient.get<City[]>(`/countries/${countryId}/cities`);
  };

  const createCity = (countryId: number, createData: CreateCityData) => {
    return apiPrivateClient.post<City>(
      `/countries/${countryId}/cities`,
      createData
    );
  };

  const updateCity = (countryId: number, updateData: CreateCityData) => {
    return apiPrivateClient.patch<City>(
      `/countries/${countryId}/cities`,
      updateData
    );
  };

  const deleteCityById = (cityId: number) => {
    return apiPrivateClient.delete<City>(`/countries/cities/${cityId}`);
  };

  return {
    createCountry,
    getCountries,
    getCountry,
    updateCountry,
    deleteCountry,
    getAllCities,
    getAllCitiesInCountry,
    createCity,
    updateCity,
    deleteCityById,
  };
};
export default useLocationService;
